export const CLEAR_STORE = 'CLEAR_STORE';

export const LOADING = 'LOADING';
export const LOADED = 'LOADED';
export const GLOBAL_ERROR = 'GLOBAL_ERROR';
export const GLOBAL_ERROR_DISMISSED = 'GLOBAL_ERROR_DISMISSED';
export const SUCCESS_TOAST_REQUESTED = 'SUCCESS_TOAST_REQUESTED';
export const SUCCESS_TOAST_DISMISSED = 'SUCCESS_TOAST_DISMISSED';

export const ADD_ESTIMATE = 'ADD_ESTIMATE';
export const ESTIMATE_SAVED = 'ESTIMATE_SAVED';
export const ESTIMATE_FAILED = 'ESTIMATE_FAILED';
export const SELECT_ESTIMATE = 'SELECT_ESTIMATE';
export const ESTIMATE_LOADED = 'ESTIMATE_LOADED';
export const CLOSE_ESTIMATE = 'CLOSE_ESTIMATE';
export const ESTIMATE_COPIED = 'ESTIMATE_COPIED';

export const CALCULATE_TAX_FAIL = 'CALCULATE_TAX_FAIL';
export const CALCULATE_TAX_SUCCESS = 'CALCULATE_TAX_SUCCESS';

export const WINDOWS_CONTAIN_INVALID_CONFIGURATIONS = 'WINDOWS_CONTAIN_INVALID_CONFIGURATIONS';

export const SAVE_TO_MY_ACCOUNT_SUCCESS = 'SAVE_TO_MY_ACCOUNT_SUCCESS';

export const ADD_CONTAINER = 'ADD_CONTAINER';
export const CONTAINER_DELETED = 'CONTAINER_DELETED';
export const CONTAINER_COPIED = 'CONTAINER_COPIED';

export const ADD_ITEM = 'ADD_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const COPY_ITEM = 'COPY_ITEM';
export const ITEM_COPIED = 'ITEM_COPIED';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';

export const RESET_CONTAINER_COUNT = 'RESET_CONTAINER_COUNT';

export const UPDATE_TOOLTIP_SELECTION = 'UPDATE_TOOLTIP_SELECTION';
export const REVERT_TOOLTIP_SELECTION = 'REVERT_TOOLTIP_SELECTION';
export const DESIGNS_SUMMARY_LOADED = 'DESIGNS_SUMMARY_LOADED';

export const SET_ORIGIN = 'SET_ORIGIN';

export const INSTALLATION_PRICING = 'INSTALLATION_PRICING';

export const THD_STORE_INFO_LOADED = 'THD_STORE_INFO_LOADED';


/* Copy Styles */
export { default as copyStyles } from './copyStyles';

/* MandI Availability */
export { default as availability } from './availability';

/* uiState */
export { default as uiState } from './uiState';

/* Share */
export { default as share } from './share';

/* MandI Rename Window Label */
export { default as renameLabel } from './renameWindowLabel/types';
